import React, { Component } from 'react';
import {Divider, Paper, Chip, Avatar, Card, CardContent, CardActions, Drawer, TableRow, TableCell, Table, TableHead, Button, IconButton, Box, LinearProgress, Grid, Link, Container, TableContainer} from "@mui/material";
import { Apps, Done, Check, SupervisedUserCircle, Edit, ArrowBack } from "@mui/icons-material";
import EditTeamLeader from './EditTeamLeader';
import Api from "../../customlib/Api";
import axios from "axios";
import Global from '../../customlib/Global';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale, Title } from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';
import DateRangePicker from '../../customlib/DateRangePicker';
import moment from 'moment';

ChartJS.register(ArcElement, Tooltip, Legend, BarElement, 
    CategoryScale,
    LinearScale,
    BarElement,
    Title);
 
class TeamLeader extends Component {
    state = { 
        bottom: false,
        appProfiles: [],
        selectedAppProfile: null,
        defaultLeaderType: "",
        isLoading: false,
        standAlone: false,
        dataLeadsByLabel: [],
        dataLeadsByLabelChart: {
            labels: ["Leads By Label"],
            datasets: [
                {
                label: '',
                data: [1,2,3,4],
                backgroundColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                ],
                borderWidth: 1,
                },
            ],
        },
        dataLeadsByTeamChart: {
            labels: ["Leads By Label"],
            datasets: [
                {
                label: '',
                data: [1,2,3,4],
                backgroundColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                ],
                borderWidth: 1,
                },
            ],
        },
        startDate: moment(new Date()).format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
    }

    toggleDrawer = (anchor, open) => (event) => {
        console.log("TOGGLE", anchor, open);
        this.setState({ ...this.state, [anchor]: open });
    };

    loadTeamLeaderList = () => {

        let params = {
            appProfileId: Global.getAppProfile()._id,
            leaderType: this.state.defaultLeaderType
        };

        this.setState({isLoading: true}, () => {
            axios
                .post(Api.teamLeaderList(), params, Api.getRequestHeader())
                .then((response) => {
                    console.log(response);
                    this.setState({appProfiles: response.data.data, isLoading: false});
                })
                .catch((error) => {
                    this.setState({isLoading: false});
                    console.error("There was an error!", error);
                });
        });
    }

    componentDidMount(){

        let defaultType = this.props.defaultType;
        let standAlone = this.props.standAlone;
        this.setState({defaultLeaderType: defaultType ? defaultType : "", standAlone: standAlone ? standAlone : false}, () => {
            this.loadTeamLeaderList();
            this.loadReport();
        });
    }

    handleDateChanged = (rangeDate) => {
    
        let startDate =  moment(rangeDate[0]).format("YYYY-MM-DD");
        let endDate =  moment(rangeDate[1]).format("YYYY-MM-DD");

        console.log("START : ", startDate, ", END : ", endDate);

        this.setState({ startDate: startDate, endDate:  endDate}, this.loadReport);
    }

    loadReport = () => {
        this.setState({isLoadingReport: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate,
                    endDate: this.state.endDate,
                    appProfileId: Global.getAppProfile()._id
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.getLeadsReportTeamLeader(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    const chartData = {...this.state.dataLeadsByLabelChart};
                    const chartDataBar = {...this.state.dataLeadsByTeamChart};

                    let arrLabels = [];
                    let arrData = [];

                    let arrLabelsBar = [];
                    let arrDataBar = [];
                    if(data.success === true){

                        let dataForPie = data.data.byLabel.filter(item => ["CLOSING", "Closing", "PENDING", "CANCEL"].includes(item.label));

                        dataForPie.forEach(element => {
                            arrLabels.push(element.label);
                            arrData.push(element.count);
                        });
                        chartData.labels = arrLabels;
                        chartData.datasets[0].data = arrData;
                        console.log("chart_data", chartData);

                        let dataByTeam = data.data.byTeam;
                        dataByTeam.forEach(element => {
                            arrLabelsBar.push(element.leaderName);
                            arrDataBar.push(element.count);
                        });
                        chartDataBar.labels = arrLabelsBar;
                        chartDataBar.datasets[0].data = arrDataBar;

                        this.setState({isLoadingReport: false, dataLeadsByLabel: data.data.byLabel, dataLeadsByLabelChart: chartData, dataLeadsByTeamChart: chartDataBar}, () => {
                            console.log("dataLeadsByLabel", this.state.dataLeadsByLabel);
                        });
                    }else{
                        this.setState({isLoadingReport: false, dataLeadsByLabel: [], dataLeadsByLabelChart: chartData});
                    }
                })
                .catch((error) => {
                  this.setState({csComplaintCategoriesLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    render() { 
        return ( 
            <Container sx={{mt: "10px"}} maxWidth={"lg"}>

                <Paper elevation={3} sx={{mt: "20px", mb: "10px", maxHeight: "600px", overflowY: "auto"}}>
                    <Box>
                        <Grid container spacing={1} justifyContent={"space-between"}>
                            <Grid item>
                                <Link href='/'>
                                    <IconButton color='primary'><ArrowBack /></IconButton>
                                </Link>
                            </Grid>
                            <Grid item>
                                <h3>Team Leader</h3>
                            </Grid>
                            <Grid item>
                                <Button variant='contained' color='primary' sx={{margin: "10px"}} startIcon={<SupervisedUserCircle />} 
                                    // onClick={this.toggleDrawer('bottom', true)}
                                    onClick={() => {this.setState({bottom: true, selectedAppProfile: null});}}
                                    >
                                    Tambah Team
                                </Button>
                            </Grid>
                        </Grid>
                        <Divider style={{marginTop: 10}} />
                        {
                            this.state.isLoading && <LinearProgress />
                        }
                        <div className="containera">
                            <Table size='small'>
                                <TableHead>
                                    <TableCell>Nama Team</TableCell>
                                    <TableCell>Nama Leader</TableCell>
                                    <TableCell>Tipe Team</TableCell>
                                    <TableCell align='right'>Jumlah Member</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell align='center'>Action</TableCell>
                                </TableHead>
                                {
                                    this.state.appProfiles.map(item => {
                                        return <TableRow>
                                            <TableCell>{item.teamLeaderName}</TableCell>
                                            <TableCell>{item.leaderName}</TableCell>
                                            <TableCell>{item.leaderType}</TableCell>
                                            <TableCell align='right'>{item.members?.length}</TableCell>
                                            <TableCell>{item.isTeamEnabled ? "ACTIVE" : "INACTIVE"}</TableCell>
                                            <TableCell align='center'>
                                                <IconButton 
                                                    size='small' 
                                                    color='primary'
                                                    onClick={() => {
                                                        this.setState({bottom: true, selectedAppProfile: item});
                                                    }}
                                                    >
                                                    <Edit />
                                                </IconButton></TableCell>
                                        </TableRow>
                                    })
                                }

                            </Table>
                        </div>
                    </Box>
                </Paper>

                <Paper elevation={5} sx={{mt: "10px", mb: "10px", padding: "10px"}}>
                    <Grid container spacing={1}>
                        <Grid item xs={6}></Grid>
                        <Grid item xs={6} textAlign={"right"}>
                            <DateRangePicker onDateChanged={this.handleDateChanged} />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <strong>Leads Summary</strong>
                            <TableContainer>
                                <Table size='small'>
                                    {
                                        this.state.dataLeadsByLabel.map(item => {
                                            return (
                                                <TableRow>
                                                    <TableCell>{item.label}</TableCell>
                                                    <TableCell>{item.count}</TableCell>
                                                </TableRow>
                                            );
                                        })
                                    }
                                    
                                </Table>
                            </TableContainer>
                        </Grid>
                        {/* <Grid item xs={12}>
                        </Grid> */}
                        <Grid item xs={12} md={5} textAlign={"center"}>
                            {
                                !this.state.isLoadingReport && <Pie data={this.state.dataLeadsByLabelChart} />
                            }
                        </Grid>
                        <Grid item xs={12}>
                            {
                                !this.state.isLoadingReport && <Bar data={this.state.dataLeadsByTeamChart} />
                            }
                        </Grid>
                    </Grid>
                </Paper>

                {['left', 'right', 'top', 'bottom'].map((anchor) => (
                    <React.Fragment key={anchor}>
                        {/* <Button onClick={this.toggleDrawer(true)}>{anchor}</Button> */}
                        <Drawer 
                            anchor={anchor} 
                            open={this.state[anchor]} 
                            onClose={this.toggleDrawer('bottom',false)}
                        >
                            {/* <TemplateMessage onCloseDrawer={() => {this.setState({right: false});}} pushMessageHandler={this.handlePushMessage} messageData={this.handleGetMessageData} onClose={this.toggleDrawer('right',false)}/> */}
                            <EditTeamLeader data={this.state.selectedAppProfile} onReload={this.loadTeamLeaderList} onClose={this.toggleDrawer('bottom',false)} />
                        </Drawer>
                    </React.Fragment> 
                ))}
            </Container>
         );
    }
}
 
export default TeamLeader;